import useTranslate from 'lib/languages/useTranslate';
import Button, {
    ButtonTypes,
} from '../../generic/button/presentational/Button';
import Typography from '../../generic/typography/presentational/Typography';
import ModalOuterContainer from '../generic/containers/ModalOuterContainer';
import { useTranslatedFeePrompt } from 'lib/hooks';
import { useGetAccountQuery } from 'lib/services';

export interface FeesModalProps {
    action: string;
    fee: number | undefined;
    handleSubmit: () => void;
    closeModal: () => void;
    isInternalPayee?: boolean;
    amount?: number;
}

const FeesModal = ({
    action,
    fee = 0,
    handleSubmit,
    closeModal,
    isInternalPayee,
    amount = 0,
}: FeesModalProps) => {
    const {
        data: { availableBalance = 0, productType } = {},
    } = useGetAccountQuery();
    const translate = useTranslate('feesModal');
    const feePromptText = useTranslatedFeePrompt(
        translate,
        action,
        fee,
        productType,
        isInternalPayee,
    );
    const isInsufficientFunds = +availableBalance < fee + Number(amount) * 100;

    return (
        <ModalOuterContainer
            className="add-cardholder-fee-modal"
            handleSubmit={handleSubmit}
            hideModal={closeModal}
            isPosting={false}
            customButtons={isInsufficientFunds}
        >
            {isInsufficientFunds ? (
                <>
                    <Typography tag="h1">
                        {translate('insufficientFunds')}
                    </Typography>
                    <Typography className="description">
                        {translate('noFunds')}
                    </Typography>
                    <Button type={ButtonTypes.SUBMIT} onClick={closeModal}>
                        {translate('ok')}
                    </Button>
                </>
            ) : (
                <>
                    <Typography tag="h1">{translate('newFee')}</Typography>
                    <Typography className="description">
                        {feePromptText}
                    </Typography>
                </>
            )}
        </ModalOuterContainer>
    );
};

export default FeesModal;
